import { Serializable } from "../utilities/Serializable";

export class SecurityDepositTotal extends Serializable {
    notes : string;
    quantity : number;
    total : number;

    constructor() {
        super();
        this.notes = "";
        this.quantity = 0;
        this.total = 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/SecurityDepositTotal.ts